import styles from "../detailPage/detail.module.css";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

const Cost = ({ sumChecker, priceChecker, carValue }) => {
  // const [isOmumi, setIsOmumi] = useState(false);
  // useEffect(() => {
  //   let flag = false;

  //   if (carValue == "omumi") {
  //     setIsOmumi(true);
  //     flag = true;
  //     console.log("carValue", carValue);
  //   }

  //   if (!flag) setIsOmumi(false);
  // }, [carValue]);

  return (
    <div>
      <div className={`d-flex flex-column  ${styles.costBox}`}>
        <div className={styles.costNav}>هزینه های متغییر</div>

        <div className={styles.flewRowCost}>
          <p className={styles.costHeader}>مجموعه هزینه ها</p>

          <p className={styles.detailCost}>پیش بینی :{addCommas(sumChecker())} تومان</p>
        </div>
        {priceChecker(0) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>گشت صبح </p>
            <p className={styles.detailCost}>پیش بینی :{addCommas(priceChecker(0))}تومان</p>
          </div>
        )}
        {priceChecker(1) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>صبحانه</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(1))} تومان</p>
          </div>
        )}

        {priceChecker(2) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>ناهار</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(2))} تومان</p>
          </div>
        )}
        {priceChecker(3) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>میان وعده</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(3))} تومان</p>
          </div>
        )}
        {priceChecker(4) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>گشت عصر</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(4))} تومان</p>
          </div>
        )}
        {priceChecker(5) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>شام</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(5))} تومان</p>
          </div>
        )}
        {priceChecker(6) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>اقامت</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(6))} تومان</p>
          </div>
        )}
        {priceChecker(7) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>برنامه شب</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(7))} تومان</p>
          </div>
        )}
        {/* {isOmumi && ( */}

        <div>
          {priceChecker(8) && (
            <div className={styles.flewRowCost}>
              <p className={styles.costHeader}>نقلیه کمکی</p>
              <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(8))} تومان</p>
            </div>
          )}
        </div>

        {/* )} */}

        {priceChecker(15) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>بیمه</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(15))} تومان</p>
          </div>
        )}
        {priceChecker(18) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>سیم کارت</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(18))} تومان</p>
          </div>
        )}
        {priceChecker(16) && (
          <div className={styles.flewRowCost}>
            <p className={styles.costHeader}>ترنسفر اصلی</p>
            <p className={styles.detailCost}>پیش بینی : {addCommas(priceChecker(16))} تومان</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cost;
